"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const nmr_processing_1 = require("nmr-processing");
const react_1 = require("react");
const ChartContext_1 = require("../context/ChartContext");
const ScaleContext_1 = require("../context/ScaleContext");
const useSpectraPerNucleus_1 = __importDefault(require("../hooks/useSpectraPerNucleus"));
const ExclusionZoneAnnotation_1 = __importDefault(require("./ExclusionZoneAnnotation"));
function ExclusionZonesAnnotationsInner({ displayerKey, xDomains, spectra, shiftY, }) {
    return ((0, jsx_runtime_1.jsx)("g", { className: "spectrum-exclusion-zones-group", clipPath: `url(#${displayerKey}clip-chart-1d)`, children: spectra
            .filter((d) => d.display.isVisible && xDomains[d.id])
            .map((d, index) => getExclusionZones(d).map((record) => {
            return record.zones.map((zone) => {
                return ((0, jsx_runtime_1.jsx)(ExclusionZoneAnnotation_1.default, { spectrumID: d.id, vAlign: shiftY * index, zone: zone, filterId: record.id, color: d.display.color }, zone.id));
            });
        })) }));
}
const MemoizedPeakAnnotations = (0, react_1.memo)(ExclusionZonesAnnotationsInner);
function ExclusionZonesAnnotations() {
    const { displayerKey, xDomains, displayerMode } = (0, ChartContext_1.useChartData)();
    const { shiftY } = (0, ScaleContext_1.useScale)();
    const spectra = (0, useSpectraPerNucleus_1.default)();
    if (displayerMode !== '1D')
        return null;
    return ((0, jsx_runtime_1.jsx)(MemoizedPeakAnnotations, { spectra: spectra, displayerKey: displayerKey, xDomains: xDomains, shiftY: shiftY }));
}
exports.default = ExclusionZonesAnnotations;
function getExclusionZones(data) {
    const zones = [];
    for (const filter of data.filters) {
        if (filter.name === nmr_processing_1.Filters.exclusionZones.id && filter.flag) {
            zones.push({ id: nmr_processing_1.Filters.exclusionZones.id, zones: filter.value });
        }
        else if (filter.name === nmr_processing_1.Filters.signalProcessing.id && filter.flag) {
            zones.push({
                id: nmr_processing_1.Filters.signalProcessing.id,
                zones: filter.value.exclusionsZones,
            });
        }
    }
    return zones;
}
